module.exports = __webpack_public_path__ + "img/flow-h.1a82cb04.svg";